import { Domain } from '../domains/domain';
import { Folder } from '../settings/folders/folder';

export class Document {
  public id?: string;
  public name: string;
  public domain?: Domain;
  public folder?: Folder;
}
